// @flow

import React, { Component } from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';
import Logger from '../utils/Logger';

class SvgIcon extends Component {

  static LOADING_BAR = 0;
  static DOWNLOAD = 1;
  static UPLOAD = 2;
  static ORDER_DELIVERY = 3;
  static ORDER_ON_SITE = 4;
  static ORDER_TAKE_AWAY = 5;
  static ORDER_AT_BAR = 6;

  static propTypes = {
    icon: PropTypes.number.isRequired,

    style: PropTypes.object,

    className: PropTypes.string,
  };

  static defaultProps = {
    style: {},
    className: "",
  };

  shouldComponentUpdate(nextProps) {
    return nextProps.icon !== this.props.icon;
  }

  renderLoadingBar(style: Object, className: string) {
    return (
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32" width="32" height="32"
        fill="white" style={style} className={className}>
        <path transform="translate(2)" d="M0 12 V20 H4 V12z">
          <animate attributeName="d"
            values="M0 12 V20 H4 V12z; M0 4 V28 H4 V4z; M0 12 V20 H4 V12z; M0 12 V20 H4 V12z"
                   dur="1.2s" repeatCount="indefinite" begin="0" keyTimes="0;.2;.5;1"
                   keySplines="0.2 0.2 0.4 0.8;0.2 0.6 0.4 0.8;0.2 0.8 0.4 0.8" calcMode="spline"/>
        </path>
        <path transform="translate(8)" d="M0 12 V20 H4 V12z">
          <animate attributeName="d"
                   values="M0 12 V20 H4 V12z; M0 4 V28 H4 V4z; M0 12 V20 H4 V12z; M0 12 V20 H4 V12z"
                   dur="1.2s" repeatCount="indefinite" begin="0.2" keyTimes="0;.2;.5;1"
                   keySplines="0.2 0.2 0.4 0.8;0.2 0.6 0.4 0.8;0.2 0.8 0.4 0.8" calcMode="spline"/>
        </path>
        <path transform="translate(14)" d="M0 12 V20 H4 V12z">
          <animate attributeName="d"
                   values="M0 12 V20 H4 V12z; M0 4 V28 H4 V4z; M0 12 V20 H4 V12z; M0 12 V20 H4 V12z"
                   dur="1.2s" repeatCount="indefinite" begin="0.4" keyTimes="0;.2;.5;1"
                   keySplines="0.2 0.2 0.4 0.8;0.2 0.6 0.4 0.8;0.2 0.8 0.4 0.8" calcMode="spline"/>
        </path>
        <path transform="translate(20)" d="M0 12 V20 H4 V12z">
          <animate attributeName="d"
                   values="M0 12 V20 H4 V12z; M0 4 V28 H4 V4z; M0 12 V20 H4 V12z; M0 12 V20 H4 V12z"
                   dur="1.2s" repeatCount="indefinite" begin="0.6" keyTimes="0;.2;.5;1"
                   keySplines="0.2 0.2 0.4 0.8;0.2 0.6 0.4 0.8;0.2 0.8 0.4 0.8" calcMode="spline"/>
        </path>
        <path transform="translate(26)" d="M0 12 V20 H4 V12z">
          <animate attributeName="d"
                   values="M0 12 V20 H4 V12z; M0 4 V28 H4 V4z; M0 12 V20 H4 V12z; M0 12 V20 H4 V12z"
                   dur="1.2s" repeatCount="indefinite" begin="0.8" keyTimes="0;.2;.5;1"
                   keySplines="0.2 0.2 0.4 0.8;0.2 0.6 0.4 0.8;0.2 0.8 0.4 0.8" calcMode="spline"/>
        </path>
      </svg>
    );
  }

  renderDownloadIcon(style: Object, className: string) {
    return (
      <svg xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 481 481" style={style} className={className}>
        <path
          d="M230.95,394.3c2.6,2.6,6.1,4,9.5,4s6.9-1.3,9.5-4l87.7-87.7c5.3-5.3,5.3-13.8,0-19.1c-5.3-5.3-13.8-5.3-19.1,0l-64.7,64.7
                V13.5c0-7.5-6-13.5-13.5-13.5s-13.5,6-13.5,13.5v338.6l-64.7-64.7c-5.3-5.3-13.8-5.3-19.1,0s-5.3,13.8,0,19.1L230.95,394.3z"
        />
        <path
          d="M439.55,354.7c-7.5,0-13.5,6-13.5,13.5V454H54.85v-85.8c0-7.5-6-13.5-13.5-13.5s-13.5,6-13.5,13.5v99.3
                c0,7.5,6,13.5,13.5,13.5h398.3c7.5,0,13.5-6,13.5-13.5v-99.3C453.05,360.7,447.05,354.7,439.55,354.7z"
        />
      </svg>
    );
  }

  renderUploadIcon(style: Object, className: string) {
    return (
      <svg xmlns="http://www.w3.org/2000/svg" x="0px" y="0px"
        viewBox="0 0 384.97 384.97" style={style} className={className}>
        <path d="M372.939,264.641c-6.641,0-12.03,5.39-12.03,12.03v84.212H24.061v-84.212c0-6.641-5.39-12.03-12.03-12.03
          S0,270.031,0,276.671v96.242c0,6.641,5.39,12.03,12.03,12.03h360.909c6.641,0,12.03-5.39,12.03-12.03v-96.242
          C384.97,270.019,379.58,264.641,372.939,264.641z"/>
        <path d="M117.067,103.507l63.46-62.558v235.71c0,6.641,5.438,12.03,12.151,12.03c6.713,0,12.151-5.39,12.151-12.03V40.95
          l63.46,62.558c4.74,4.704,12.439,4.704,17.179,0c4.74-4.704,4.752-12.319,0-17.011l-84.2-82.997
          c-4.692-4.656-12.584-4.608-17.191,0L99.888,86.496c-4.752,4.704-4.74,12.319,0,17.011
          C104.628,108.211,112.327,108.211,117.067,103.507z"/>
      </svg>
    );
  }

  renderOrderDeliveryIcon(style: Object, className: string) {
    return (
      <svg viewBox="0 0 436.842 436.842" style={style} className={className}>
        <path d="M343.746,154.841c-12.696,0-24.804,2.558-35.842,7.18l-26.394-51.211h36.89c4.002,0,7.258,3.256,7.258,7.258
          s-3.256,7.258-7.258,7.258h-7.871c-4.143,0-7.5,3.358-7.5,7.5s3.357,7.5,7.5,7.5h7.871c12.273,0,22.258-9.985,22.258-22.258
          s-9.984-22.258-22.258-22.258h-49.192c-2.615,0-5.042,1.363-6.404,3.596c-1.361,2.233-1.461,5.015-0.263,7.34l13.125,25.467H167.423
          l-10.92-21.403h17.269c4.143,0,7.5-3.358,7.5-7.5s-3.357-7.5-7.5-7.5h-49.193c-4.143,0-7.5,3.358-7.5,7.5s3.357,7.5,7.5,7.5h15.084
          l14.576,28.568l-17.132,26.543c-13.113-7.065-28.101-11.08-44.011-11.08C41.763,154.841,0,196.603,0,247.936
          c0,51.333,41.763,93.096,93.096,93.096c48.808,0,88.961-37.757,92.793-85.596h22.007l-8.549,27.818h-4.922
          c-4.143,0-7.5,3.358-7.5,7.5s3.357,7.5,7.5,7.5h27c4.143,0,7.5-3.358,7.5-7.5s-3.357-7.5-7.5-7.5h-6.386l9.869-32.114l62.406-96.327
          l7.269,14.103c-26.357,16.458-43.933,45.723-43.933,79.02c0,51.333,41.763,93.096,93.097,93.096
          c51.333,0,93.096-41.763,93.096-93.096C436.842,196.603,395.079,154.841,343.746,154.841z M162.121,154.826l43.678,85.61h-19.911
          c-2.162-26.985-15.882-50.758-36.193-66.359L162.121,154.826z M170.824,240.436h-63.96l34.661-53.699
          C157.734,199.592,168.745,218.724,170.824,240.436z M93.096,326.032C50.033,326.032,15,290.999,15,247.936
          c0-43.062,35.033-78.096,78.096-78.096c12.914,0,25.095,3.17,35.837,8.743l-42.139,65.285c-1.489,2.307-1.598,5.244-0.284,7.655
          c1.313,2.411,3.84,3.912,6.586,3.912h77.728C167.036,294.992,133.628,326.032,93.096,326.032z M218.819,232.949l-43.743-85.737
          h99.289L218.819,232.949z M343.746,326.032c-43.063,0-78.097-35.034-78.097-78.096c0-27.498,14.298-51.704,35.838-65.623
          l35.592,69.059c1.332,2.583,3.954,4.065,6.673,4.065c1.157,0,2.331-0.269,3.43-0.835c3.683-1.897,5.129-6.42,3.231-10.103
          l-35.603-69.079c8.956-3.586,18.714-5.581,28.936-5.581c43.063,0,78.096,35.034,78.096,78.096
          C421.842,290.999,386.809,326.032,343.746,326.032z"/>
      </svg>
    );
  }

  renderOrderOnSite(style: Object, className: string) {
    return (
      <svg viewBox="-5.5 -4.849 258 235" style={style} className={className}>
        <path d="M-0.963,126.016v29.012L-1,227.301h7.667v-64.982h72v64.982H86l0.443-66.508c8.548-2.89,14.722-10.978,14.722-20.486
          c0-11.922-9.699-21.623-21.621-21.623l-72.877,0.299V0h-7.333L-0.963,126.016z M6.838,127.488h76.375
          c4.938,0,8.952,5.899,8.952,13.151s-4.017,13.154-8.952,13.154H6.838V127.488L6.838,127.488z"/>
        <path d="M249.667,0h-7.333v118.981l-72.878-0.299c-11.922,0-21.621,9.7-21.621,21.623c0,9.51,6.174,17.598,14.722,20.485
          l0.443,66.51l7.334-0.002v-64.981h72v64.981H250l-0.037-72.272v-29.012L249.667,0z M242.162,153.795h-76.375
          c-4.936,0-8.951-5.903-8.951-13.155s4.016-13.151,8.951-13.151h76.375V153.795z"/>
        <polygon points="39.5,89.651 210,89.651 210,98.151 129,98.151 129,226.651 121,226.651 121,98.151 39.5,98.151 	"/>
      </svg>
    );
  }

  renderOrderTakeAway(style: Object, className: string) {
    return (
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 235.503 235.503" style={style} className={className}>
        <path
          d="M202.127,124.088c-1.395-0.581-2.974-0.276-4.048,0.813l-6.636,6.624V83.959c0-13.312-7.923-25.503-19.934-31.095V20.1
          c0.461-0.607,0.865-1.274,0.865-2.098V3.723c0-2.058-1.654-3.723-3.719-3.723h-0.865h-21.443h-0.89
          c-2.052,0-3.711,1.665-3.711,3.723v14.279c0,0.832,0.417,1.523,0.882,2.136v32.719c-12.027,5.574-19.932,17.761-19.932,31.096
          v43.098l-2.174-2.164c-0.675-0.674-1.701-0.982-2.717-1.01V95.72c0-5.252-2.347-9.883-5.941-13.171
          c3.484-2.005,5.941-5.624,5.941-9.916c0-6.376-5.202-11.582-11.578-11.582H54.094c-6.398,0-11.604,5.2-11.604,11.582
          c0,4.292,2.457,7.902,5.943,9.908c-3.597,3.296-5.943,7.927-5.943,13.179v34.228l-5.071-5.069
          c-1.076-1.078-2.659-1.387-4.051-0.806c-1.387,0.553-2.292,1.903-2.292,3.43v104.27c0,2.06,1.665,3.731,3.715,3.731h165.765
          c2.048,0,3.703-1.655,3.719-3.715l0.152-104.286C204.427,126.012,203.509,124.649,202.127,124.088z M196.853,228.093H38.509
          v-91.622l3.99,3.991l3.715,3.728l3.711,3.711l2.829,2.837c1.395,1.379,3.859,1.379,5.25,0l18.174-18.186l18.174,18.186
          c1.395,1.379,3.863,1.379,5.251,0l10.764-10.78l3.713-3.727l3.643-3.631l0.068,0.076l4.907,4.89l7.42,7.413l4.793,4.785
          l0.949,0.95c1.395,1.426,3.863,1.382,5.246,0l0.966-0.95l17.216-17.248l17.236,17.248l0.949,0.95c1.395,1.382,3.863,1.382,5.246,0
          l0.949-0.95h0.321v-0.309l7.43-7.45l5.534-5.534L196.853,228.093z M49.917,72.633c0-2.292,1.87-4.144,4.17-4.144h52.132
          c2.296,0,4.154,1.851,4.154,4.144c0,2.292-1.857,4.155-4.154,4.155H54.086C51.794,76.794,49.917,74.925,49.917,72.633z
          M60.492,85.148h39.321c5.827,0,10.568,4.741,10.568,10.58v10.866H49.925V95.728C49.917,89.889,54.649,85.148,60.492,85.148z
          M49.917,114.003h60.456v15.443l-13.393,13.396l-17.953-17.965c-1.396-1.387-4.294-1.387-5.692,0l-17.959,17.965l-5.458-5.454
          V114.003z M150.059,7.418h14.029v6.862h-14.029V7.418z M130.125,83.943c0-11.122,7.037-21.231,17.513-25.148
          c1.471-0.545,2.421-1.925,2.421-3.48V21.716h14.029v33.598c0,1.555,0.966,2.936,2.408,3.473
          c10.488,3.939,17.525,14.04,17.525,25.156v4.178h-53.896V83.943z M130.125,95.555h53.896v43.401l-3.896,3.887l-17.953-17.965
          c-1.411-1.387-4.341-1.387-5.719,0l-17.941,17.965l-8.363-8.367v-38.92H130.125z"
        />
        <path
          d="M175.971,163.81h-0.017c-2.052,0-3.711,1.655-3.711,3.695l-0.028,15.625l-0.016,7.409l-0.048,17.833H63.255v-17.833
          v-3.723v-3.711v-15.609c0-2.039-1.663-3.71-3.713-3.71c-2.048,0-3.715,1.671-3.715,3.71v14.399v3.971v3.723v22.51
          c0,2.04,1.667,3.72,3.715,3.72h116.32c2.048,0,3.702-1.655,3.719-3.72l0.048-21.56l0.012-7.409l0.057-15.598
          C179.681,165.48,178.01,163.81,175.971,163.81z"
        />
      </svg>
    );
  }

  renderOrderAtBar(style: Object, className: string) {
    return (
      <svg viewBox="0 0 463 463" style={style} className={className}>
        <path d="M455.5,220H7.5c-4.142,0-7.5,3.358-7.5,7.5v32c0,4.142,3.358,7.5,7.5,7.5H8v136.5c0,4.142,3.358,7.5,7.5,7.5H120v17
          h-16.5c-4.142,0-7.5,3.358-7.5,7.5c0,4.142,3.358,7.5,7.5,7.5h48c4.142,0,7.5-3.358,7.5-7.5c0-4.142-3.358-7.5-7.5-7.5H135v-17
          h193v17h-16.5c-4.142,0-7.5,3.358-7.5,7.5c0,4.142,3.358,7.5,7.5,7.5h48c4.142,0,7.5-3.358,7.5-7.5c0-4.142-3.358-7.5-7.5-7.5
          H343v-17h104.5c4.142,0,7.5-3.358,7.5-7.5V267h0.5c4.142,0,7.5-3.358,7.5-7.5v-32C463,223.358,459.642,220,455.5,220z M120,396
          H23V267h52.262l10.133,45.598C87.802,323.433,97.236,331,108.335,331H120V396z M108.335,316c-4.015,0-7.427-2.737-8.298-6.656
          L97.739,299H159.5c4.687,0,8.5,3.813,8.5,8.5s-3.813,8.5-8.5,8.5H108.335z M328,364h-24.5c-4.142,0-7.5,3.358-7.5,7.5
          c0,4.142,3.358,7.5,7.5,7.5H328v17H135v-17h24.5c4.142,0,7.5-3.358,7.5-7.5c0-4.142-3.358-7.5-7.5-7.5H135v-33h24.5
          c12.958,0,23.5-10.542,23.5-23.5S172.458,284,159.5,284h-64c-0.366,0-0.726,0.026-1.078,0.077L90.627,267h281.745l-3.795,17.077
          c-0.352-0.051-0.711-0.077-1.078-0.077h-64c-12.958,0-23.5,10.542-23.5,23.5s10.542,23.5,23.5,23.5H328V364z M303.5,316
          c-4.687,0-8.5-3.813-8.5-8.5s3.813-8.5,8.5-8.5h61.761l-2.298,10.344c-0.871,3.919-4.283,6.656-8.298,6.656H303.5z M440,396h-97
          v-65h11.665c11.099,0,20.533-7.567,22.94-18.402L387.738,267H440V396z M448,252h-0.5h-56.525
          c0.247-3.636-2.181-7.007-5.848-7.821c-4.04-0.898-8.049,1.651-8.948,5.694L375.706,252H87.294l-0.473-2.127
          c-0.899-4.043-4.902-6.594-8.948-5.694c-3.666,0.814-6.095,4.186-5.848,7.821H15.5H15v-17h433V252z"/>
        <path d="M455.5,20H7.5C3.358,20,0,23.358,0,27.5v32C0,63.642,3.358,67,7.5,67H96v25.723c-18.205,3.515-32,19.561-32,38.777
          c0,4.142,3.358,7.5,7.5,7.5H96v0.5c0,4.142,3.358,7.5,7.5,7.5c4.142,0,7.5-3.358,7.5-7.5V139h24.5c4.142,0,7.5-3.358,7.5-7.5
          c0-19.216-13.795-35.262-32-38.777V67h113v25.723c-18.205,3.515-32,19.561-32,38.777c0,4.142,3.358,7.5,7.5,7.5H224v0.5
          c0,4.142,3.358,7.5,7.5,7.5c4.142,0,7.5-3.358,7.5-7.5V139h24.5c4.142,0,7.5-3.358,7.5-7.5c0-19.216-13.795-35.262-32-38.777V67
          h113v25.723c-18.205,3.515-32,19.561-32,38.777c0,4.142,3.358,7.5,7.5,7.5H352v0.5c0,4.142,3.358,7.5,7.5,7.5
          c4.142,0,7.5-3.358,7.5-7.5V139h24.5c4.142,0,7.5-3.358,7.5-7.5c0-19.216-13.795-35.262-32-38.777V67h88.5
          c4.142,0,7.5-3.358,7.5-7.5v-32C463,23.358,459.642,20,455.5,20z M126.826,124H80.174c3.175-9.853,12.432-17,23.326-17
          S123.651,114.147,126.826,124z M254.826,124h-46.652c3.175-9.853,12.432-17,23.326-17C242.394,107,251.651,114.147,254.826,124z
          M382.826,124h-46.652c3.175-9.853,12.432-17,23.326-17S379.651,114.147,382.826,124z M448,52H15V35h433V52z"/>
      </svg>
    );
  }

  render() {
    const renderers = [
      {
        icon: SvgIcon.LOADING_BAR,
        handler: this.renderLoadingBar
      },
      {
        icon: SvgIcon.DOWNLOAD,
        handler: this.renderDownloadIcon
      },
      {
        icon: SvgIcon.UPLOAD,
        handler: this.renderUploadIcon
      },
      {
        icon: SvgIcon.ORDER_DELIVERY,
        handler: this.renderOrderDeliveryIcon
      },
      {
        icon: SvgIcon.ORDER_ON_SITE,
        handler: this.renderOrderOnSite
      },
      {
        icon: SvgIcon.ORDER_TAKE_AWAY,
        handler: this.renderOrderTakeAway
      },
      {
        icon: SvgIcon.ORDER_AT_BAR,
        handler: this.renderOrderAtBar
      }
    ];

    const info = _.find(renderers, (info) => {
      return info.icon === this.props.icon;
    });

    if (_.isUndefined(info)) {
      Logger.notImplemented('SvgIcon', `Invalid SvgIcon icon: ${this.props.icon}`);
      return (null);
    }

    return info.handler(this.props.style, this.props.className);
  }

}

export default SvgIcon;
